import { useState, type FormEvent } from "react";

const categories = [
  "개인보험",
  "근재보험",
  "교통사고",
  "손해배상",
  "화재",
  "누수",
];

export default function Inquiry() {
  return (
    <section
      id="inquiry"
      className="relative bg-background-100 py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 lg:col-start-3">
            <div className="text-primary-600 text-xs tracking-[0.32em] font-semibold mb-4 text-center">
              CONTACT US
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight text-center">
              막막한 보상,<br />
              <span className="text-primary-600">다다손해사정</span>이 함께합니다
            </h2>
            <p className="mt-6 text-foreground-700 leading-relaxed text-center max-w-2xl mx-auto">
              접수하신 내용은 24시간 이내 담당 손해사정사가 직접 연락드립니다.
              사건 검토 후 진행 여부를 함께 결정합니다.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
              <a href="tel:010-2696-9689" className="flex items-center gap-4 p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-400 transition">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shrink-0">
                  <i className="ri-phone-fill text-xl"></i>
                </span>
                <div>
                  <div className="text-xs text-foreground-600">대표번호</div>
                  <div className="font-heading font-bold text-xl text-foreground-950">
                    010-2696-9689
                  </div>
                </div>
              </a>
              <div className="flex items-center gap-4 p-5 bg-background-50 rounded-lg border border-background-200">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-foreground-950 text-primary-400 shrink-0">
                  <i className="ri-map-pin-line text-xl"></i>
                </span>
                <div>
                  <div className="text-xs text-foreground-600">본점 오시는 길</div>
                  <div className="font-semibold text-foreground-900 text-sm mt-0.5">
                    경기도 고양시 덕양구 백양로 32-31 효원빌딩 506호
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4 p-5 bg-background-50 rounded-lg border border-background-200">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 shrink-0">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <div>
                  <div className="text-xs text-foreground-600">이메일</div>
                  <div className="font-semibold text-foreground-900 text-sm mt-0.5">
                    dcsnow@naver.com
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}